export const API_URL = '/api/'; // Cambia la URL según tu API
export const MAPBOX_TOKEN = 'pk.eyJ1IjoibnRmb3Jlc3QiLCJhIjoiY2w5enFsdmZ3MGh4MjNvbnpjN3g0dTNpayJ9.PTDFh30UdY7dzAZtoRjojg'; // Tu token de Mapbox
export const MAPBOX_STYLE = 'mapbox://styles/mapbox/satellite-streets-v11'; // Estilo del mapa de Mapbox
